module.exports = __webpack_public_path__ + "img/Anindya_Dutta-1-498x500.9d55f815.png";